// const _ = require('lodash');
// ## update language
// please update and checking following languages files

// 1. /schema
// 2. PageSchema.vue
// 3. /lang/index.js
// 4. /packages/helper/terms.js
// 5. /packages/helper/mediatypes/*.js

// const en = _.merge(require('@motionelements/core/src/lang/json/en.json'), require('./json/en.json'));
// const ja = _.merge(require('@motionelements/core/src/lang/json/ja.json'), require('./json/ja.json'));
// const ko = _.merge(require('@motionelements/core/src/lang/json/ko.json'), require('./json/ko.json'));

import en from './json/en.json';
import ja from './json/ja.json';
import ko from './json/ko.json';

const languages = {
  en,
  ja,
  ko,
};

const preLoadedLanguages = Object.keys(languages);

export {
  languages, // lang json array
  preLoadedLanguages,
};
